/**
 * The machine code of a thrown API error — the ONLY thing a screen may branch
 * its copy on.
 *
 * A failed call used to reach the user as `err.message`: the server's English
 * sentence, written for logs ("Reminder already sent recently for this task",
 * "Forbidden"), or a network library's ("Failed to fetch"), on a surface that
 * is otherwise in the reader's language. A screen now reads the CODE here —
 * `@tonnie/sdk`'s `TonnieApiError.code`, a `DOMAIN_ERROR_CODES` value or the
 * status-family floor (`TOO_MANY_REQUESTS`, `NETWORK_ERROR`) — picks translated
 * copy for the codes it can explain, and shows its own translated fallback for
 * everything else. The message is never read.
 *
 * Structural, so anything a `catch` can receive is safe to pass: an Error
 * without a code, a string, `null`.
 */
export function apiErrorCode(err: unknown): string | null {
  if (typeof err !== 'object' || err === null) return null;
  const code = (err as { code?: unknown }).code;
  return typeof code === 'string' && code.length > 0 ? code : null;
}
